import { Select } from "antd";
import { Flex } from "src/components/Flex";
import { SearchContext } from "src/search/useSearchContext";
import { ExploreContext } from "../useExploreContext";

export enum TimeUnit {
  AUTO = "auto",
  MINUTES = "minutes", // pluralized for backwards compatibility with TimeSeries
  HOURS = "hours",
  DAYS = "days",
  MONTHS = "months",
}

export function isTimeUnit(value: TimeUnit | string) {
  return Object.values(TimeUnit).includes(value as TimeUnit);
}

export type FormattingConfig = {
  timeUnit: TimeUnit;
};

export const toFormattingConfig: (
  data: FormattingConfig | any,
  defaults?: Partial<FormattingConfig>
) => FormattingConfig = (data, defaults = {}) => ({
  timeUnit: isTimeUnit(data?.timeUnit)
    ? data.timeUnit
    : defaults.timeUnit || TimeUnit.AUTO,
});

export function hasTimeUnit(
  query:
    | SearchContext["aggregations"]
    | SearchContext["entitiesList"]
    | ExploreContext["entitiesList"]
) {
  return query.data?.meta.columnInfo.some(
    (col) =>
      col.type === "number" &&
      ["millisecond", "hour", "minute", "second", "businesssecond"].includes(
        col.unit as string
      )
  );
}

export function FormattingControls(props: {
  disabled: boolean;
  timeUnit: TimeUnit;
  onChangeTimeUnit(value: TimeUnit): void;
}) {
  return (
    <Flex spaceBetween style={{ marginTop: 8 }}>
      <div className="viz-label">Time format</div>
      <Select
        className={["viz-select", props.disabled ? "disabled" : ""].join(" ")}
        disabled={props.disabled}
        value={props.timeUnit}
        onChange={(color) => props.onChangeTimeUnit!(color)}
        popupMatchSelectWidth={false}
        bordered={false}
        options={[
          {
            value: TimeUnit.AUTO,
            label: <span className="viz-select-option">Automatic</span>,
          },
          {
            value: TimeUnit.MINUTES,
            label: <span className="viz-select-option">Minutes</span>,
          },
          {
            value: TimeUnit.HOURS,
            label: <span className="viz-select-option">Hours</span>,
          },
          {
            value: TimeUnit.DAYS,
            label: <span className="viz-select-option">Days</span>,
          },
          {
            value: TimeUnit.MONTHS,
            label: <span className="viz-select-option">Months</span>,
          },
        ]}
      />
    </Flex>
  );
}
